import { Client, Suscripcion } from '../types/index';

export const getValidClients = (clients: Client[], nextMonth: number): Client[] => {
  // Crear una copia profunda de los datos de clients
  const clientsCopy: Client[] = JSON.parse(JSON.stringify(clients));
  console.log("nextMonth", nextMonth);
  console.log("clientsCopy", clientsCopy);

  // Filtrar los clientes que tienen una suscripción con un campo beneficiario
  const clientsWithBeneficiario = clientsCopy.filter(client =>
    client.suscripciones.some(suscripcion => suscripcion.activo && suscripcion.beneficiario)
  );

  console.log("clientsWithBeneficiario", clientsWithBeneficiario);


  // Función auxiliar para calcular el importe con descuento
  const calcularImporteConDescuento = (suscripcion: Suscripcion): number => {
    return Math.max(0, suscripcion.importeSuscripcion - (suscripcion.descuento || 0));
  };

  // Crear un mapa para buscar suscripciones por ID
  // Resto el descuento de la suscripción principal
  const suscripcionesMap = new Map();
  clientsCopy.forEach(client => {
    client.suscripciones.forEach(suscripcion => {
      suscripcionesMap.set(suscripcion._id, suscripcion);
      suscripcion.importeSuscripcion = calcularImporteConDescuento(suscripcion);
    });
  });

  // Sumar el importe de la suscripción del beneficiario al importe de la suscripción del cliente
  clientsWithBeneficiario.forEach(client => {
    client.suscripciones.forEach(suscripcion => {
      if (suscripcion.beneficiario) {
        console.log("suscripcion principal", suscripcion);
        const beneficiarioSuscripcion = suscripcionesMap.get(suscripcion.beneficiario);
        if (beneficiarioSuscripcion && !beneficiarioSuscripcion.mesesInactivos.includes(nextMonth)) {
          //en suscripcionesMap ya se restaron los decuentos solo queda sumar el importe del beneficiario
          suscripcion.importeSuscripcion += beneficiarioSuscripcion.importeSuscripcion;
        }
      } 
    });
  });

  console.log("clientsCopy antes del ultimo filtrado", clientsCopy);
  // Filtrar los clientes que tienen una suscripción activa y un IBAN o un pagador con IBAN
  return clientsCopy.filter(client =>
    client.suscripciones.some(suscripcion =>
      suscripcion.activo &&
      (suscripcion.pagador?.IBAN || suscripcion.iban) &&
      !suscripcion.pagador_id &&
      !suscripcion.mesesInactivos.includes(nextMonth)
    )
  );
};

export const getNextMonthAndYear = () => {
  const today = new Date();
  const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
  
  return {
    month: nextMonth.getMonth() + 1, // +1 porque getMonth() devuelve 0-11
    year: nextMonth.getFullYear()
  };
};


// Función para obtener el color de fondo de los eventos según el nivel
// Ahora retorna el color hex directamente desde el objeto nivel
export const getEventBackgroundColor = (nivel: { nombre: string; color?: string } | string | null | undefined): string => {
    // Nivel borrado: el populate devuelve null y `typeof null === 'object'`, así
    // que sin este corte se leería `.color` de null y caería el calendario entero.
    if (!nivel) return '#6b7280';

    // Si recibe un objeto nivel con color, retornarlo
    if (typeof nivel === 'object' && nivel.color) {
        return nivel.color;
    }
    
    // Fallback: si solo recibe el nombre como string, buscar en mapeo legacy
    const nivelNombre = typeof nivel === 'string' ? nivel : nivel.nombre;
    
    // Mapeo legacy para compatibilidad (si el nivel no tiene color en BD)
    const legacyColors: { [key: string]: string } = {
        'PRE PILATES': '#697076',
        'PRINCIPIANTES': '#651010',
        'BÁSICO 1': '#c79d33',
        'BÁSICO 1.1': '#7b6627',
        'BÁSICO 2': '#F27414',
        'INTERMEDIO 1': '#00b050',
        'INTERMEDIO 2': '#00b0f0',
        'PILATES GENERAL': '#9b59b6',
        'PRE PILATES 1.1': '#4a5568'
    };
    
    return legacyColors[nivelNombre] || '#40a136'; // Color por defecto heredado del diseño antiguo
};

export const formatDate = (dateString: string | Date): string => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
  });
};

/**
 * Convierte una fecha a formato YYYY-MM-DD sin problemas de zona horaria
 * @param date - Fecha a convertir
 * @returns String en formato YYYY-MM-DD
 */
export const formatDateToLocal = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

/**
 * Formatea los meses de pagos pendientes para mostrar en mensajes de confirmación
 * @param pagos - Array de pagos con estado 'Abierto'
 * @returns String formateado con los meses y años de los pagos pendientes
 */
export const formatPendingMonths = (pagos: any[]): string => {
    const meses = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    
    const monthsInfo = pagos.map(pago => ({
        mes: meses[pago.mes - 1],
        anio: pago.anio
    }));
    
    // Agrupar por año
    const groupedByYear = monthsInfo.reduce((acc, { mes, anio }) => {
        if (!acc[anio]) acc[anio] = [];
        acc[anio].push(mes);
        return acc;
    }, {} as Record<number, string[]>);
    
    // Formatear el texto
    const yearGroups = Object.entries(groupedByYear).map(([year, months]) => {
        if (months.length === 1) {
            return `${months[0]} ${year}`;
        } else {
            return `${months.join(', ')} (${year})`;
        }
    });
    
    return yearGroups.join(', ');
};
/**
 * Ids de los clientes inscritos en una clase, venga la lista como ids o como
 * clientes ya poblados.
 *
 * El tipo `Evento` declara `clientesInscritos: string[]`, pero la API los
 * devuelve **poblados**, así que en tiempo de ejecución son objetos. Al reenviar
 * el evento en un PUT se mandaban esos objetos, y el backend —que compara con
 * `.toString()` para saber a quién se ha añadido o quitado— recibía la cadena
 * "[object Object]": la auditoría guardaba basura y el aviso al cliente
 * reventaba al castear. Lo guardado siempre estuvo bien, porque Mongoose castea
 * el documento poblado a su `_id`, y por eso nadie lo vio.
 *
 * El backend ya normaliza por su cuenta; esto evita además mandar el objeto
 * entero por la red y hace que el cuerpo cuadre con el tipo que declara.
 */
export const idsDeInscritos = (inscritos: unknown[] | undefined | null): string[] =>
    (inscritos ?? []).map((c) => String((c as { _id?: string } | null)?._id ?? c));
